import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { i18n, loadLocaleMessages, SUPPORTED_LOCALES } from '@/i18n'

const HomePage = () => import('@/views/HomePage.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: () => {
      const browserLang = navigator.language?.split('-')[0] ?? 'en'
      const locale = SUPPORTED_LOCALES.includes(browserLang) ? browserLang : 'en'
      return `/${locale}`
    },
  },
  {
    path: '/:locale',
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
      },
    ],
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 80 }
    return { top: 0, behavior: 'smooth' }
  },
})

router.beforeEach(async (to) => {
  const locale = (to.params.locale as string) || 'en'

  if (to.params.locale && !SUPPORTED_LOCALES.includes(locale)) {
    return `/${i18n.global.locale.value}`
  }

  if (locale !== i18n.global.locale.value) {
    await loadLocaleMessages(locale)
    i18n.global.locale.value = locale
  }

  const rtlLocales = new Set(['ar', 'fa', 'he', 'ur'])
  document.documentElement.lang = locale
  document.documentElement.dir = rtlLocales.has(locale) ? 'rtl' : 'ltr'
})
